import React from 'react';
import { MDXProvider } from '@mdx-js/react';

import { getLayout as getBaseLayout } from './Base';
import SEO from '../SEO';
import { components } from '../../mdx';

const DocsLayout = ({ children, pageContext, location }) => {
  return (
    <React.Fragment>
      <SEO
        title={pageContext?.node?.childMdx?.frontmatter?.title}
        location={location}
      />

      <MDXProvider components={components}>{children}</MDXProvider>
    </React.Fragment>
  );
};

export const getLayout = (props, element) =>
  getBaseLayout(<DocsLayout {...props}>{element}</DocsLayout>);

export default DocsLayout;
